import axios from "axios";
import { apiURI, authErrorRedirect } from "../../../common";
import { validateApprovalInput } from "../../../requests/validation/validateApprovalInput";

export function handleProcurementApproval(setErrors, id, decoded, history) {
  return ({ e, approval, value }) => {
    e.preventDefault();
    setErrors({});
    const { validationErrors, isValid } = validateApprovalInput(value);
    !isValid && setErrors(validationErrors);

    const editForm = {
      id,
      approval,
      role: decoded.role,
      comments: value.comments,
      email: decoded.email,
    };
    isValid &&
      axios
        .post(`${apiURI}/form/procApproval`, editForm)
        .then(() => window.location.reload(true))
        .catch((response) => {
          console.log("error in axios login call react");
          setErrors({});
          setErrors(response.response.data);
          authErrorRedirect(response.response.data, history);
        });
  };
}
